import React from 'react';

export const Footer = () => {
	return (
		<footer>
			<div>
				<p>Lillemor Eriksson and Joel Harde</p>
			</div>
		</footer>
	);
};
